import React, { useState, useEffect, useCallback } from "react";
import ConnectWalletBtn from "../components/ConnectWalletBtn";
import { images } from "../shared/images";
import { nftUrl } from "../shared/config";
import { useParams } from "react-router-dom";
import axios from "axios";
import nfmStakingAbi from "../shared/blockchain/nfmStakingAbi.json";
import nfmAbi from "../shared/blockchain/nfmAbi.json";
import { ethers } from "ethers";
import { CONSTANTS } from "../shared/constants";
import toast from "react-hot-toast";

const BotDetail = () => {
  const [isWalletConnected, setIsWalletConnected] = useState(true);
  const [walletAddress, setWalletAddress] = useState("");
  const [network, setNetwork] = useState(0);
  const [isAlreadyStaked, setIsAlreadyStaked] = useState(false);
  const [nftDetails, setNftDetails] = useState(null);
  const [isAlreadyApproved, setIsAlreadyApproved] = useState(false);

  const param = useParams();

  const fetchNftDetail = useCallback(async () => {
    try {
      const response = await axios.get(`${nftUrl}/nft/metadata/${param.id}`);
      if (response.status === 200) {
        // console.log(response.data);
        setNftDetails(response.data);
      } else {
        setNftDetails(null);
        // throw new Error(response?.data?.message);
      }
    } catch (error) {
      console.log("Something Went Wrong: " + error);
    }
  }, [param.id]);

  function format_time(s) {
    const dtFormat = new Intl.DateTimeFormat("en-US", {
      timeStyle: "medium",
      timeZone: "UTC",
    });

    return dtFormat.format(s);
  }

  useEffect(() => {
    const fetchData = async () => {
      let wallet_connection = localStorage.getItem("wallet_connection");
      let wallet_address = localStorage.getItem("wallet_address");
      let chain_id = localStorage.getItem("chain_id");
      setIsWalletConnected(wallet_connection);
      setWalletAddress(wallet_address);
      setNetwork(chain_id);

      if (wallet_connection === true || wallet_connection === "true") {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const address = await signer.getAddress();

        const NFMSTAKING = new ethers.Contract(
          CONSTANTS.NFM_STAKING_CONTRACT,
          nfmStakingAbi,
          signer
        );
        const NFM = new ethers.Contract(CONSTANTS.NFM_CONTRACT, nfmAbi, signer);

        const nfmStakeStatus = await NFMSTAKING.getNFMStakeStatus(
          address,
          CONSTANTS.NFM_CONTRACT,
          param.id
        );
        setIsAlreadyStaked(nfmStakeStatus);

        const _isAlreadyApproved = await NFM.isApprovedForAll(
          address,
          CONSTANTS.NFM_STAKING_CONTRACT
        );
        setIsAlreadyApproved(_isAlreadyApproved);
      }
    };

    fetchData();

    fetchNftDetail();
  }, [fetchNftDetail]);

  function createToast(url) {
    toast.loading((t) => (
      <span>
        Transaction pending... <br></br>
        <button onClick={() => window.open(url, "_blank")}>
          <b>View Transaction</b>
        </button>
      </span>
    ));
  }

  const approveNFM = async () => {
    try {
      if (isWalletConnected === true || isWalletConnected === "true") {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const address = await signer.getAddress();
        const NFM = new ethers.Contract(CONSTANTS.NFM_CONTRACT, nfmAbi, signer);
        await NFM.setApprovalForAll(CONSTANTS.NFM_STAKING_CONTRACT, true)
          .then((transaction) => {
            let explorer = `${CONSTANTS.EXPLORER_URL}/tx/${transaction.hash}`;
            createToast(explorer);
            toast.success("Transaction Initiated");
            return provider.waitForTransaction(transaction.hash);
          })
          .then(function (transactionReceipt) {
            console.log(transactionReceipt);
            if (transactionReceipt.byzantium) {
              toast.dismiss();
              toast.success("Approve Successfully, Please proceed to stake");
              setIsAlreadyApproved(true);
            } else {
              toast.dismiss();
              toast.error("Transaction Failed");
              setIsAlreadyApproved(false);
            }
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const stakeNFM = async () => {
    try {
      if (isWalletConnected === true || isWalletConnected === "true") {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const NFMSTAKING = new ethers.Contract(
          CONSTANTS.NFM_STAKING_CONTRACT,
          nfmStakingAbi,
          signer
        );
        await NFMSTAKING.stake(CONSTANTS.NFM_CONTRACT, param.id)
          .then((transaction) => {
            let explorer = `${CONSTANTS.EXPLORER_URL}/tx/${transaction.hash}`;
            createToast(explorer);
            toast.success("Transaction Initiated");
            return provider.waitForTransaction(transaction.hash);
          })
          .then(function (transactionReceipt) {
            console.log(transactionReceipt);
            if (transactionReceipt.byzantium) {
              toast.dismiss();
              toast.success("NFM staked Successfully");
              reloadPage();
            } else {
              toast.dismiss();
              toast.error("Transaction Failed");
            }
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const unStakeNFM = async () => {
    try {
      if (isWalletConnected === true || isWalletConnected === "true") {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const NFMSTAKING = new ethers.Contract(
          CONSTANTS.NFM_STAKING_CONTRACT,
          nfmStakingAbi,
          signer
        );
        await NFMSTAKING.unStake(CONSTANTS.NFM_CONTRACT, param.id)
          .then((transaction) => {
            let explorer = `${CONSTANTS.EXPLORER_URL}/tx/${transaction.hash}`;
            createToast(explorer);
            toast.success("Transaction Initiated");
            return provider.waitForTransaction(transaction.hash);
          })
          .then(function (transactionReceipt) {
            console.log(transactionReceipt);
            if (transactionReceipt.byzantium) {
              toast.dismiss();
              toast.success("NFM unstaked Successfully");
              reloadPage();
            } else {
              toast.dismiss();
              toast.error("Transaction Failed");
            }
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  function reloadPage() {
    setTimeout(function () {
      window.location.reload();
    }, 2000);
  }

  // const { image, name, compiler, collection_date, attributes } = nftDetails;

  // console.log(new Date());
  return (
    <div className="bot-detail">
      <div className="bot-detail__banner">
        <img src={images.stakingBanner} alt="Staking Banner" />
      </div>

      {/* Connect Wallet Button */}
      <ConnectWalletBtn source="stake"/>

      {!isWalletConnected && (
        <h1 className="text-center">Please Connect Your Wallet</h1>
      )}

      {isWalletConnected && (
        <>
          {nftDetails ? (
            <>
              <div className="bot-detail__info">
                <div className="bot-detail__info--image">
                  <img src={nftDetails?.image} alt="NFT" />
                  {/* If staked add stamp */}
                  {isAlreadyStaked && (
                    <div className="image-layer-stamp">
                      <img src={images.staked} alt="Staked Stamp" />
                    </div>
                  )}
                </div>
                <div className="bot-detail__info--text">
                  <div>
                    <h1>{nftDetails?.name}</h1>
                    <p>by NitroNetworkNFT</p>
                    <p>
                      <small>NitroBotArmy</small>
                    </p>
                  </div>

                  <div>
                    <p>
                      <span>Compiler:</span>
                      <span>{nftDetails?.compiler}</span>
                    </p>
                    <p>
                      <span>Collection Date:</span>
                      <span>
                        Created {format_time(nftDetails?.collection_date)}
                      </span>
                    </p>

                    {/* wallet connected, already staked, */}
                    {isWalletConnected && isAlreadyStaked && (
                      <button
                        onClick={unStakeNFM}
                        className="btn btn-white text-black w-100"
                      >
                        UnStake
                      </button>
                    )}

                    {/* wallet connected, not staked, already approved, */}
                    {isWalletConnected &&
                      !isAlreadyStaked &&
                      isAlreadyApproved && (
                        <button
                          onClick={stakeNFM}
                          className="btn btn-white text-black w-100"
                        >
                          Stake
                        </button>
                      )}

                    {/* wallet connected, not staked, not approved, */}
                    {isWalletConnected &&
                      !isAlreadyStaked &&
                      !isAlreadyApproved && (
                        <button
                          onClick={approveNFM}
                          className="btn btn-white text-black w-100"
                        >
                          Approve
                        </button>
                      )}

                    {/* {isAlreadyStaked ? (
                      <button
                        onClick={() => {
                          setIsAlreadyStaked(false);
                        }}
                        className="btn btn-white text-black w-100"
                      >
                        UnStake
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          setIsAlreadyStaked(true);
                        }}
                        className="btn btn-white text-black w-100"
                      >
                        Stake
                      </button>
                    )} */}
                  </div>
                </div>
              </div>

              <div className="bot-detail__attributes">
                <h1>Attributes</h1>

                <div className="pink-boxes">
                  {nftDetails?.attributes?.map((attribute, i) => (
                    <div key={i} className="box">
                      <p className="text-center">{attribute?.trait_type}</p>
                      <h2>{attribute?.value}</h2>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <h1 className="text-center">Something Went Wrong...!</h1>
          )}
        </>
      )}

      <div className="bot-detail__about">
        <h1>About Nitro Bot Army</h1>

        <p>
          Nitro Network is an exciting new project that aims to bring awareness
          and utility to the world of IoT and private networks. Nitro Bot Army
          is a collection of 7,500 generative art NFTs, each with the power to
          unlock the door of NitroVerse, where the bot army is fighting against
          the dark by educating real-world users about IoT usage in daily lives.
        </p>

        <p>
          As a holder of a Nitro Bot Army NFT, you will benefit from a range of
          rewards and utilities, including IP of comic content of NitroVerse,
          royalties, staking rewards, community campaign rewards, access to
          Nitro events, and token burn.
        </p>

        <p>
          But that's not all! Nitro Network also offers discounts on IoT
          products on our IoT Marketplace and entry to various programs where
          you can work with the team to build a better future.
        </p>

        <p>
          By owning a Nitro Bot Army NFT, you not only become a part of a
          revolutionary project that is creating awareness and utility for the
          world of IoT, but you also gain access to exclusive benefits and
          rewards.
        </p>
      </div>
    </div>
  );
};

export default BotDetail;
